/* eslint-disable @typescript-eslint/no-unused-vars */
import { useContext, useEffect, useState } from 'react';

import Banner from 'components/informative-animated-banner';
import { Container, LoadingOlist } from 'components/layout';
import { AlertContext } from 'contexts/alert-context';
import { AuthContext } from 'contexts/auth';
import { sendGTMEvent } from 'helpers/google-tag-manager';
import useBanksList from 'hooks/use-banks-list';
import { AnimatedCalendar } from 'images';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import Api from 'service';
import {
  BANK_ACCOUNT_TAG,
  handleNextStepBySellerTag,
} from 'utils/first-steps-validation/first-steps-validation';

import { Box, Flex, Text } from '@olist/united';

import { BankAccountForm } from './components/bank-account-form/bank-account-form';
import BankAccountHeader from './components/bank-account-header';
import BankDoubts from './components/bank-doubts';

const BankAccountPage = () => {
  const { t } = useTranslation();

  const [openModal, setOpenModal] = useState(false);
  const { isGtmLoaded, userInfo } = useContext(AuthContext);
  const { setAlert } = useContext(AlertContext);
  const { optionsBank } = useBanksList();
  const [isCheckingSellerTag, setIsCheckingSellerTag] = useState(false);
  const history = useHistory();

  const checkIsSellerTagCreated = async () => {
    try {
      const responseValues = await Api.getSellerTags();

      const isCompletedBankAccount =
        responseValues && responseValues.sellerTags.includes(BANK_ACCOUNT_TAG);

      if (isCompletedBankAccount) {
        const redirectValue = handleNextStepBySellerTag(responseValues.sellerTags);
        setIsCheckingSellerTag(false);
        history.push(redirectValue);
      }
    } catch (error) {
      setIsCheckingSellerTag(false);
      setAlert({
        text: t`An error occurred and the information could not be sent. Try again.`,
        show: true,
        iconName: 'alert-triangle-outline',
      });
    }
  };

  useEffect(() => {
    if (isCheckingSellerTag) {
      checkIsSellerTagCreated();
      const intervalPolling = setInterval(async () => {
        checkIsSellerTagCreated();
      }, 2500);
      return () => clearInterval(intervalPolling);
    }
    return null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isCheckingSellerTag]);

  useEffect(() => {
    if (userInfo?.email && isGtmLoaded) {
      sendGTMEvent('page_view', { user_id: userInfo.email });
    }
  }, [userInfo?.email, isGtmLoaded]);

  const displayDocumentNumber = userInfo?.documentNumber;

  const bannerOptions = {
    badgeLabel: t`predictability`,
    file: AnimatedCalendar,
    title: t`uncomplicated financials`,
    subTitle: t`have a forecast of future transfers and receive it every 1st, 10th and 20th of the month*.`,
    listLabel: t`*holidays and weekdays fall on the next working day`,
  };

  if (isCheckingSellerTag) {
    return <LoadingOlist />;
  }

  return (
    <Container>
      <Text.H3 mt={2} mb={4} fontWeight="semibold">
        {t`get paid for your sales`}
      </Text.H3>
      <Flex flexDirection={['column', 'column', 'column', 'row']} mb={3}>
        <Flex
          flex={2}
          flexDirection="column"
          width={[1, 1, 1, '650px']}
          minWidth={[1, 1, 1, '400px']}
        >
          <BankAccountHeader cnpj={displayDocumentNumber} />
          <BankDoubts banks={optionsBank} setOpenModal={setOpenModal} openModal={openModal} />
          <BankAccountForm setOpenModal={setOpenModal} setSuccess={setIsCheckingSellerTag} />
        </Flex>
        <Box
          paddingLeft={8}
          flex={5 / 2}
          flexDirection={['column']}
          alignItems="flex-end"
          display={['none', 'none', 'none', 'flex']}
        >
          <Banner {...bannerOptions} />
        </Box>
      </Flex>
    </Container>
  );
};

export default BankAccountPage;
